export const ru = {
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    'copy-link': 'Копировать условия в буфер обмена',
    'day-description': {
        one: 'за {count} день',
        some: 'за {count} дня',
        many: 'за {count} дней',
        none: 'за {count} дней'
    },
    interests: 'Интересы',
    metrikaAudience: 'Яндекс.Аудитории и Яндекс.Метрика',
    'open-popup-text': 'Посмотреть условия показа',
    'popup-title': 'Условия показа',
    'users-profiles': 'Профиль пользователя'
};
